import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Layout } from "@/components/Layout";
import { LanguageToggle } from "@/components/LanguageToggle";
import { setToken } from "@/lib/auth";
import { PRAT_T } from "@/data/praticien";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatApiErrorDetail = (detail, fallback) => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
};

export default function PractitionerLogin() {
  const [lang, setLang] = useState("fr");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const t = PRAT_T[lang];

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.token);
      navigate("/praticien/tableau-de-bord");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail, t.errorGeneric));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="flex items-center justify-between mb-8 no-print">
        <Link to="/" data-testid="prat-back-home" className="text-sm text-[var(--ink-soft)] hover:text-[var(--gold)] transition-colors">{t.backHome}</Link>
        <LanguageToggle lang={lang} onChange={setLang} />
      </div>
      <div className="max-w-md mx-auto animate-fade-up">
        <h1 className="font-serif-title text-4xl text-[var(--gold)] text-center mb-2">{t.loginTitle}</h1>
        <p className="text-sm text-[var(--ink-soft)] text-center mb-8">{t.loginSub}</p>
        <form onSubmit={submit} className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] p-6 sm:p-8 space-y-5">
          <div>
            <label htmlFor="prat-email" className="block text-sm text-[var(--ink)] mb-1.5 font-medium">{t.emailLabel}</label>
            <input id="prat-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="prat-email-input"
              className="w-full rounded-xl border border-[var(--border)] bg-white/80 p-3 focus:outline-none focus:border-[var(--gold)]" />
          </div>
          <div>
            <label htmlFor="prat-password" className="block text-sm text-[var(--ink)] mb-1.5 font-medium">{t.passwordLabel}</label>
            <input id="prat-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="prat-password-input"
              className="w-full rounded-xl border border-[var(--border)] bg-white/80 p-3 focus:outline-none focus:border-[var(--gold)]" />
          </div>
          {error && <p className="text-sm text-[#B0553B]" data-testid="prat-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="prat-login-btn"
            className={`w-full px-8 py-3.5 rounded-full font-medium shadow-sm transition-all ${loading ? "bg-[var(--beige)] text-[var(--ink-soft)]" : "bg-[var(--gold)] text-white hover:brightness-105"}`}>
            {loading ? t.signing : t.loginBtn}
          </button>
          <div className="text-center">
            <Link to="/praticien/mot-de-passe-oublie" data-testid="prat-forgot-link" className="text-sm text-[var(--ink-soft)] hover:text-[var(--gold)]">{t.forgotLink}</Link>
          </div>
        </form>
      </div>
    </Layout>
  );
}
